"use strict";
/**
 * Предоставляет инструменты для работы с кэш-хранилищем.
 *
 * @namespace WebAccess.cache
 * @since 5.0.0.7100
 */
(function (global) {  

    var Cache = BaseObject.extend({
      _errorCatched: false,
      init: function (data) {
        var me = this;
      },

      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
      _data: {
        setItem: function (key, value) {
          this[key] = value;
          return this;
        },
        removeItem: function(key) {
          delete this[key];
        },
        getItem: function (key) {
          return this[key];          
        },
        clear: function () {
          for (p in this) {
            if (!$.isFunction(this[p])) {
              delete this[p];
            }
          }
          return this;
        }
      },
      className: "Cache",
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
      * Проверить, поддерживается ли браузером локальное хранилище (localStorage).
      *
      * @function WebAccess.cache.isLocalStorageAvailable
      * @return {boolean} True – локальное хранилище поддерживается браузером, иначе False.
      * @since 5.0.0.7100 
      * @since 5.1.0.1505 RENAMED_FROM isLocalStorageAvailable 
      */
      isStorageAvailable: function () {
        return !!(window["localStorage"]) && !this._errorCatched;
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /**
      * @private 
      * @method WebAccess.cache._getStorage
      */
      _getStorage: function () {
        if (this.isStorageAvailable) return window.localStorage;
        else {
          log.warn('CACHE', 'LocalStorage is not available for this browser, using local variable instead');
          return this._data;
        }
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
      * Удалить значение.
      *
      * @function WebAccess.cache.removeItem
      * @param {string} key Ключ кэш-хранилища     
      * @return {WebAccess.cache} Объект типа cache.
      * @since  5.1.0.1534 
      */
      removeItem: WA.TCD(function (key) {
        var me = this;
        try {
        this._getStorage().removeItem(key);        
        this.fire('itemRemoved', key);
        } catch (e) {
          log.error('CACHE', e);
          me._errorCatched = true;
        }
        return this;
      }),
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
      * Сохранить значение в кэш.
      *
      * @function WebAccess.cache.setItem
      * @param {string} key Ключ кэш-хранилища   
      * @param {string} value Сохраняемое значение. Объекты не сохраняются
      * @return {WebAccess.cache} Объект типа cache.
      * @since 5.0.0.7100
      */
      setItem: function (key, value) {
        var me = this;
        try {
        this._getStorage().setItem(key, value);        
        this.fire('itemSet', key, value);
        } catch (e) {
          log.error('CACHE',e);
          me._errorCatched = true;        
        }

        return this;
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
      * Получить значение из кэша.
      *
      * @function WebAccess.cache.getItem
      * @param {string} key Ключ кэш-хранилища   
      * @return {String|Integer} Полученное значение типа String или Integer.
      * @since 5.0.0.7100
      */
      getItem: function (key) {
          return this._getStorage().getItem(key);        
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
      * Сохранить объект в кэш.
      *
      * @function WebAccess.cache.setObject
      * @param {string} key Ключ
      * @param {object} value Сохраняемый объект
      * @return {WebAccess.cache} Объект типа cache.
      * @since 5.0.0.7100
      */
      setObject: WA.TCD(function(key, value) {
        this.setItem(key, $.toJSON(value));
        return this;
      }),
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
      * Получить объект из кэша.
      *
      * @function WebAccess.cache.getObject
      * @param {string} key Ключ
      * @return {object} Полученный объект.
      * @since 5.0.0.7100
      */
      getObject: function (key) {
         var value = this.getItem(key);
         return value && (value !=='undefined' ? $.parseJSON(value) : null);
      },
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

      /** 
       * Очистить кэш.
       *
       * @function WebAccess.cache.clear
       * @return {WebAccess.cache} Объект типа cache.
       * @since 5.0.0.7100
       */
      clear: function () {
        this._getStorage().clear();
        return this;
      }    
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    });

    
    global.cache = new Cache();
    global.cache.Cache = Cache;
})(window.WebAccess);